import SolidButton from '@/components/Common/Button/SolidButton'
import { useTranslation } from 'react-i18next'

const SubmissionComplete = () => {
  const { t } = useTranslation('common')
  return (
    <>
      <div className="flex items-center justify-center">
        <p className="text-sm font-semibold text-normal lg:text-lg">{t('cta.submitted.message')}</p>
      </div>
      <div className="w-full lg:max-w-[160px]">
        <SolidButton className="!h-10 !w-full lg:!h-11" disabled={true}>
          {t('cta.submitted.button')}
        </SolidButton>
      </div>
    </>
  )
}

export default SubmissionComplete
